import { isOneOf } from '@pba/utils';
import { useTranslation } from 'react-i18next';
import { appLanguageCodes, locales } from '#i18n';

export const useIsTwelveHourFormat = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const locale = isOneOf(language, appLanguageCodes) ? locales[language] : locales.en;

  return (
    new Intl.DateTimeFormat(locale, {
      hour: 'numeric',
    }).resolvedOptions().hour12 === true
  );
};
